// Dependency-free slug utilities. Kept free of any `wasp/*` import so it can be
// unit-tested in isolation (importing wasp/server triggers env validation).

export function generateSlug(text: string): string {
  return text
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^a-z0-9\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
}

// Canonical slug shape: lowercase alphanumerics in hyphen-separated groups.
// No slashes, dots, hosts, or leading/trailing hyphens. A slug that fails this
// is what poisoned the sitemap (a full URL pasted into the slug field), so it
// is enforced at the API boundary AND defensively filtered out of the sitemap.
export const SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export function isValidSlug(slug: string): boolean {
  return SLUG_PATTERN.test(slug);
}
